import { createContext } from 'react';
import { WithIframeTransmitterType } from './types';

export const IframeTransmitterContext = createContext<Partial<WithIframeTransmitterType>>({});
